<div class="row">
  <div class="col-sm-12 col-lg-12 col-md-12">
    <kendo-panelbar #panelbar>
      <!--Change title-->
      <kendo-panelbar-item title="{{lblText.invoiceDetailTitleLbl?lblText.invoiceDetailTitleLbl:lienRelease.invoiceDetailTitleLbl}}"
                           [expanded]="true">
        <ng-template kendoPanelBarContent>
          <form [formGroup]="lienReleaseForm">
            <div class="row m-top">
              <div class="col-sm-3"></div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label class="lbl">{{lblText.invoiceNumberLbl?lblText.invoiceNumberLbl:lienRelease.invoiceNumberLbl}}<span class="requiredField">*</span></label>
                  <kendo-numerictextbox formControlName="invoiceNumber"
                                        [format]="'#'" [spinners]="false"
                                        class="kendoInput" (blur)="validateLienReleasePanel1()" [ngClass]="{'borderRed':(lienRelease.isEmptyInvoiceNumber || lienRelease.isInvoiceNumberInValid) && lienRelease.isContinued}"></kendo-numerictextbox>
                  <span title="{{lblText.invalidInvoiceNumberLbl?lblText.invalidInvoiceNumberLbl:lienRelease.invalidInvoiceNumberLbl}}" *ngIf="lienRelease.isInvoiceNumberInValid" kendoTooltip
                        class="k-icon k-i-information k-i-info spanInfo"></span>
                </div>
                <div class="form-group">
                  <label class="lbl">{{lblText.selectLienTypeLbl?lblText.selectLienTypeLbl:lienRelease.selectLienTypeLbl}}</label>
                  <kendo-dropdownlist class="kendoInput" formControlName="lienType" [data]="lienRelease.lienTypeData"
                                      (selectionChange)="selectLienType($event)" textField="name" valueField="value">
                  </kendo-dropdownlist>
                </div>
                <div class="form-group" *ngIf="lienRelease.showThruDate">
                  <label class="lbl">{{lblText.progressLienThruDateLbl?lblText.progressLienThruDateLbl:lienRelease.progressLienThruDateLbl}}</label>
                  <kendo-datepicker class="kendoInput" formControlName="progressLienThruDate" placeholder="MM/DD/YYYY"
                                    format="MM/dd/yyyy" [max]="maxDate" [ngClass]="{'borderRed':lienRelease.isEmptyLienThruDate && lienRelease.isContinued}" (blur)="checkLienThruDate()">
                  </kendo-datepicker>
                  <span title="Progress date must be less than todays date and should not be empty" *ngIf="showDi" kendoTooltip
                        class="k-icon k-i-information k-i-info spanInfo"></span>
                </div>

                <div class="form-group">
                  <kendo-switch formControlName="notary" name="toggle" onLabel="Yes" offLabel="No" (click)="showFaxNumber()">
                  </kendo-switch>
                  <label class="lblCheck">
                    {{lblText.notaryRequiredLbl?lblText.notaryRequiredLbl:lienRelease.notaryRequiredLbl}}
                    {{lblText.businessDaysToProcessLbl?lblText.businessDaysToProcessLbl:lienRelease.businessDaysToProcessLbl}}
                  </label>
                </div>
                <div class="form-group" *ngIf="isNotaryChecked">
                  <label class="lbl">{{lblText.faxLbl?lblText.faxLbl:lienRelease.faxLbl}}</label>
                  <kendo-numerictextbox [format]="'#'" [spinners]="false" formControlName="faxNumber" class="kendoInput"></kendo-numerictextbox>
                </div>
                <div class="form-group">
                  <p>
                    <strong>
                      {{lblText.lienReleaseTermsAndConditionsLbl?lblText.lienReleaseTermsAndConditionsLbl:lienRelease.lienReleaseTermsAndConditionsLbl}}
                    </strong>
                  </p>
                  <span>{{lblText.lienReleaseTermsAndConditionsTex1tLbl?lblText.lienReleaseTermsAndConditionsTex1tLbl:lienRelease.lienReleaseTermsAndConditionsTex1tLbl}}</span>
                </div>
                <div class="form-group">
                  <kendo-switch (click)="showDownloadLienRelease()" formControlName="termsConditions" name="toggle" onLabel="Yes" offLabel="No">
                  </kendo-switch>
                  <label class="lblCheck">
                    {{lblText.acceptTermsAndConditionsLbl?lblText.acceptTermsAndConditionsLbl:lienRelease.acceptTermsAndConditionsLbl}}
                  </label>
                </div>

              </div>
              <div class="col-sm-3"></div>
            </div>
          </form>
          <div class="col-sm-12 center" *ngIf="isTermsChecked">
            <button kendoButton primary="true" class="continue-button m-3"
                    (click)="continueToDownload()" [disabled]="lienRelease.continueInProcess">
              {{lblText.continueLbl?lblText.continueLbl:lienRelease.continueLbl}}
              <kendo-loader *ngIf="lienRelease.continueInProcess" style="color:blue"></kendo-loader>
            </button>
          </div>

        </ng-template>
      </kendo-panelbar-item>
      <kendo-panelbar-item title="{{lblText.downoadTitleLbl?lblText.downoadTitleLbl:lienRelease.downoadTitleLbl}}"
                           [expanded]="false">
        <ng-template kendoPanelBarContent>
          <form [formGroup]="lienDownloadForm">
            <div class="row m-top">
              <div class="col-sm-2"></div>
              <div class="col-sm-8">
                <p>{{lblText.noSelectionTextLbl?lblText.noSelectionTextLbl:lienRelease.noSelectionTextLbl}}</p>
                <div class=" row">

                  <div class="col-sm-5">
                    <div class="form-group">
                      <label class="lbl">{{lblText.paidDefaultLbl?lblText.paidDefaultLbl:lienRelease.paidDefaultLbl}}</label>
                    </div>
                    <div class="form-group">
                      <label class="lbl">{{lblText.paidByKawneerLbl?lblText.paidByKawneerLbl:lienRelease.paidByKawneerLbl}}</label>
                    </div>
                    <div class="form-group">
                      <label class="lbl">
                        {{lblText.paidByCustomerLbl?lblText.paidByCustomerLbl:lienRelease.paidByCustomerLbl}}
                        {{lienRelease.customerName}}
                      </label>
                    </div>
                  </div>
                  <div class="col-sm-2">
                    <div class="form-group">
                      <input type="radio" kendoRadioButton value="paidDefault" formControlName="paidType" (click)="toggle('paidDefault')" [checked]="lienRelease.paidDefaultSelected" />
                    </div>
                    <div class="form-group">
                      <input type="radio" kendoRadioButton value="paidByOwner" formControlName="paidType" (click)="toggle('paidByOwner')" [checked]="lienRelease.paidByOwnerSelected" />
                    </div>
                    <div class="form-group">
                      <input type="radio" kendoRadioButton value="paidByCustomer" formControlName="paidType" (click)="toggle('paidByCustomer')" [checked]="lienRelease.paidByCustomerSelected" />
                    </div>
                  </div>
                  <div class="col-sm-5 middleSpace">
                    <input type="text" kendoTextBox class="kendoInput" name="paidDefaultAmount" formControlName="paidDefaultAmount" disabled="disabled"  />
                    <input type="text" kendoTextBox class="kendoInput" name="paidByOwnerAmount" formControlName="paidByOwnerAmount" disabled="disabled" />

                    <kendo-numerictextbox formControlName="paidByCustomerAmount"
                                          [format]="'c2'" [spinners]="false"
                                          class="kendoInput numericTxtCls" [disabled]="!isEnabled" [ngClass]="{'borderRed':lienRelease.isEmptyAmount && lienRelease.isSubmitted && isEnabled}" (blur)="validateCustomerAmount()"></kendo-numerictextbox>
                  </div>
                </div>
                <div class="col-sm-12 center">
                  <button kendoButton class="m-3 btn btn-success"
                          (click)="downloadLienRelease()" [disabled]="lienRelease.downloadInProgress">
                    {{lblText.continueDownloadLbl?lblText.continueDownloadLbl:lienRelease.continueDownloadLbl}}<kendo-loader *ngIf="lienRelease.downloadInProgress" style="color:blue"></kendo-loader>
                  </button>
                </div>
              </div>
              <div class="col-sm-2"></div>
            </div>
          </form>
        </ng-template>
      </kendo-panelbar-item>


    </kendo-panelbar>
    <kendo-dialog title="{{lblText.lienReleaseTextLbl?lblText.lienReleaseTextLbl:lienRelease.lienReleaseTextLbl}}" *ngIf="isLienNotarySubmitted" (close)="closeLienReleaseNotaryPopup()">
      <p style="margin: 30px; text-align: center;">
        {{lblText.lienNotarySubmittedTextLbl?lblText.lienNotarySubmittedTextLbl:lienRelease.lienNotarySubmittedTextLbl}}
      </p>
      <!--<kendo-dialog-actions>
        <button class='k-button k-primary' (click)="closeLienReleaseNotaryPopup()" primary="true">
          {{lienRelease.LienCloseTextLbl}}
        </button>
      </kendo-dialog-actions>-->
    </kendo-dialog>
  </div>
</div>
